import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";

import { foodActions } from ".";

import { IFoodState } from "./food.types";
import {
  CLEAR_FOOD_STATE,
  CLEAR_LEAD_FOOD_MENU_STATE,
  FETCH_CATEGORY_LIST_FAILED,
  FETCH_CATEGORY_LIST_PROGRESS,
  FETCH_CATEGORY_LIST_SUCCESS,
  FETCH_FOOD_ITEMS_LIST_FAILED,
  FETCH_FOOD_ITEMS_LIST_PROGRESS,
  FETCH_FOOD_ITEMS_LIST_SUCCESS,
  FETCH_FOOD_MENUS_LIST_FAILED,
  FETCH_FOOD_MENUS_LIST_PROGRESS,
  FETCH_FOOD_MENUS_LIST_SUCCESS,
  FETCH_LEAD_FOOD_MENUS_LIST_FAILED,
  FETCH_LEAD_FOOD_MENUS_LIST_PROGRESS,
  FETCH_LEAD_FOOD_MENUS_LIST_SUCCESS,
  FETCH_SINGLE_FOOD_MENU_PROGRESS,
  FETCH_SINGLE_FOOD_MENU_SUCCESS,
  FETCH_SINGLE_FOOD_MENU_FAILED,
} from "./foodActions";
import { initialFoodState } from "./defaultState";

export const foodReducer = (
  state: IStoreState["food"] = initialFoodState,
  action: foodActions,
) => {
  switch (action.type) {
    // food items reducer
    case FETCH_FOOD_ITEMS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodItem.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_FOOD_ITEMS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodItem.loading = LoadState.Loaded;
        draftState.foodItem.data = data;
        draftState.foodItem.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_FOOD_ITEMS_LIST_FAILED: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodItem.loading = LoadState.Failed;
      });
      return newState;
    }

    // food menus reducer
    case FETCH_FOOD_MENUS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodMenu.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_FOOD_MENUS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodMenu.loading = LoadState.Loaded;
        draftState.foodMenu.data = data;
        draftState.foodMenu.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_FOOD_MENUS_LIST_FAILED: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodMenu.loading = LoadState.Failed;
      });
      return newState;
    }

    // single food menu reducer
    case FETCH_SINGLE_FOOD_MENU_PROGRESS: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.singleFoodMenu.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_FOOD_MENU_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.singleFoodMenu.loading = LoadState.Loaded;
        draftState.singleFoodMenu.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_FOOD_MENU_FAILED: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.singleFoodMenu.loading = LoadState.Failed;
      });
      return newState;
    }

    // lead food menus reducer
    case FETCH_LEAD_FOOD_MENUS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.leadFoodMenu.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_LEAD_FOOD_MENUS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.leadFoodMenu.loading = LoadState.Loaded;
        draftState.leadFoodMenu.data = data;
      });
      return newState;
    }
    case FETCH_LEAD_FOOD_MENUS_LIST_FAILED: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.leadFoodMenu.loading = LoadState.Failed;
      });
      return newState;
    }

    // categories reducer
    case FETCH_CATEGORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodCategory.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodCategory.loading = LoadState.Loaded;
        draftState.foodCategory.data = data;
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_FAILED: {
      const newState = produce(state, (draftState: IFoodState) => {
        draftState.foodCategory.loading = LoadState.Failed;
      });
      return newState;
    }

    // categories with food items reducer
    // case FETCH_CATEGORY_LIST_WITH_FOOD_ITEMS_PROGRESS: {
    //   const newState = produce(state, (draftState: IFoodState) => {
    //     draftState.foodCategoryWithItems.loading = LoadState.InProgress;
    //   });
    //   return newState;
    // }
    // case FETCH_CATEGORY_LIST_WITH_FOOD_ITEMS_SUCCESS: {
    //   const { data } = action.payload;
    //   const newState = produce(state, (draftState: IFoodState) => {
    //     draftState.foodCategoryWithItems.loading = LoadState.Loaded;
    //     draftState.foodCategoryWithItems.data = data;
    //   });
    //   return newState;
    // }
    // case FETCH_CATEGORY_LIST_WITH_FOOD_ITEMS_FAILED: {
    //   const newState = produce(state, (draftState: IFoodState) => {
    //     draftState.foodCategoryWithItems.loading = LoadState.Failed;
    //   });
    //   return newState;
    // }

    case CLEAR_FOOD_STATE: {
      return initialFoodState;
    }
    case CLEAR_LEAD_FOOD_MENU_STATE: {
      return {
        ...state,
        leadFoodMenu: initialFoodState.leadFoodMenu,
      };
    }
    default:
      return state;
  }
};
